import moment from 'moment';

export const defaultCliente = {
    id: 0,
    idMax: 0,
    identificationTypeId: 1,
    identification: '',
    name: '',
    lastName: '',
    birthdate: null,
    sex: null,
    phoneNumber: '',
    phoneNumberWork: '',
    cellNumber: '',
    correo: '',
    nacionalityId: null,
    departmentId: null,
    cityId: null,
    addess: '',
    professionId: null,
    sexId: null,
    sendNotification: null,
    active:true
}
